import util from '@bmp-vue/core/api/util'

const controller = 'RegistroBoleto'

export default Object.assign({}, util.GetCrud(controller, ['get', 'getall', 'post']), {
  ImpressaoBoleto: function (id) {
    return util.Axios.GetBlob(controller + '/ImpressaoBoleto/' + id)
  },
  RelatorioBoletoRegistrado: function (dto) {
    return util.Axios.GetAll(controller + '/RelatorioBoletoRegistrado', dto)
  },
  ConsultarRegistro: function (dto) {
    return util.Axios.Post(controller + '/ConsultarRegistro', dto)
  },
  BuscarQRCode: function (id) {
    return util.Axios.Get(controller + '/BuscarQRCode', id)
  },
  ConsultaBoletoPDF: function (dto) {
    return util.Axios.GetBlob(controller + '/ConsultaBoletoPDF', dto)
  }
})
